import {MergeBoxSectionHeader} from '../common/MergeBoxSectionHeader'
import {MergeQueueEntry} from './MergeQueueEntry'
import type {MergeQueue as MergeQueueData, MergeQueueEntry as MergeQueueEntryData} from '../../../types'

export type Props = {
  mergeQueue: MergeQueueData
  mergeQueueEntry: MergeQueueEntryData
  viewerCanAddAndRemoveFromMergeQueue: boolean
  onDequeueSuccess: () => void
}

export function MergeQueueSection({
  mergeQueue,
  mergeQueueEntry,
  viewerCanAddAndRemoveFromMergeQueue,
  onDequeueSuccess,
}: Props) {
  return (
    <MergeQueueEntry
      mergeQueue={mergeQueue}
      mergeQueueEntry={mergeQueueEntry}
      viewerCanAddAndRemoveFromMergeQueue={viewerCanAddAndRemoveFromMergeQueue}
      onDequeueSuccess={onDequeueSuccess}
    >
      <MergeBoxSectionHeader title={<MergeQueueEntry.Title />} rightSideContent={<MergeQueueEntry.DequeueAction />}>
        <MergeQueueEntry.Description />
      </MergeBoxSectionHeader>
    </MergeQueueEntry>
  )
}
